module.exports = __webpack_public_path__ + "img/IMG_6955.926465b6.webp";